import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import { environment } from '../../../../environments/environment';
import { AuthenticationService } from '../authentication/authentication.service';
import {catchError} from 'rxjs/operators';
import {ToasterService} from '../../global/toaster.service';
import {LoadingService} from '../../global/loading.service';
import {ResponseContentType} from '@angular/http';

@Injectable()
export class ResourcesService {
  private _resourceServer = environment.resourceServer;

  constructor(private _http: HttpClient,
              private _auth: AuthenticationService,
              private _toasterService: ToasterService,
              private _loadingService: LoadingService) { }

  get(url: string, authenticate = true, responseType?: string, observe?: string): Observable<any> {
    const headersOptions = {};
    if (authenticate) {
      headersOptions['Authorization'] = 'Bearer ' + this._auth.access_token;
    }
    const headers = new HttpHeaders(headersOptions);
    const options = {
      headers: headers,
      responseType: responseType as 'json'
    };

    if (observe) {
      options['observe'] = observe;
    }
    return this._http
      .get(this._resourceServer + url, options)
      .pipe(
        catchError(
          (error) => {
            this._loadingService.showLoading = false;
            if (error.error) {
              this._toasterService.showError(error.error.message || error.error.error);
            }
            return [];
          }
        )
      );
  }

  post(url: string, params: any, onError = () => {}): Observable<any> {
    const headersOptions = {};
    headersOptions['Authorization'] = 'Bearer ' + this._auth.access_token;
    const headers = new HttpHeaders(headersOptions);
    const options = {
      headers: headers
    };
    return this._http
      .post(this._resourceServer + url, params, options)
      .pipe(
        catchError(
          (error) => {
            this._toasterService.showError(error.error.message || error.error.error);
            onError();
            return [];
          }
        )
      );
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/api/resources/resources.service.ts